import styled, { css } from 'styled-components';

export const SectionPlans = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PlanListTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const PlansRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: stretch;
    width: 100%;
    overflow: hidden;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }    
  `}    
`;
